module.exports = function() {
  return new Worker(__webpack_public_path__ + "36dd7177ae744b444ff1.worker.js");
};